<div class="flex w-full">
  <ng-lottie class="mx-auto w-[60rem] h-[60rem]" [options]="lottieOptions"></ng-lottie>
</div>
